import React from "react"
import CalculatorSearchInput from "./shared/calculatorSearchInput/CalculatorSearchInput"
import CalculatorRangeSlider from "./shared/calculatorRangeSlider/CalculatorRangeSlider"

const Calculator = ({ locale }) => {
  // const locale =
  //   window.location.href === "https://bg.dianurse.com/food-navigator-ii/"
  //     ? "bg"
  //     : "en"
  return (
    <div>
      <CalculatorSearchInput locale={locale} />
      <CalculatorRangeSlider locale={locale} />
    </div>
  )
}

export default Calculator
